document.addEventListener( 'DOMContentLoaded', function () {
  const widgetContainer = document.querySelector( '.bigmarker-conference-widget-container' );

  if ( !widgetContainer ) return;

  const observer = new MutationObserver( ( mutations, obs ) => {
    const form = widgetContainer.querySelector( '.register_member' );
    if ( form ) {
      // Form has been loaded inside widget
      initInputClassHandlers( form );
      obs.disconnect(); // stop observing
    }
  } );

  observer.observe( widgetContainer, {
    childList: true,
    subtree: true
  } );

  function initInputClassHandlers( container ) {
    const inputs = container.querySelectorAll( 'input[type="text"], input[type="email"], input[type="tel"]' );

    inputs.forEach( ( input ) => {
      const wrapper = input.closest( '.bigmarker-widget-form-list' );
      if ( !wrapper ) return;

      // Add class if already filled
      if ( input.value.trim() !== '' ) {
        wrapper.classList.add( 'input-active' );
      }

      input.addEventListener( 'focus', () => {
        wrapper.classList.add( 'input-active' );
      } );

      input.addEventListener( 'blur', () => {
        if ( input.value.trim() === '' ) {
          wrapper.classList.remove( 'input-active' );
        }
      } );
    } );
  }
} );